document.addEventListener('DOMContentLoaded', function () {
  var FeatSlide = new Swiper(".ImgFeat_slide", {
    slidesPerView: 2.2,
    spaceBetween: 5,
    slidesPerGroup: 3, // Matches slidesPerView
    pagination: {
      el: ".ImgFeat-pagination",
      clickable: true,
    },
    grid: {
      rows: 2,
      fill: 'row' // Recommended for top-to-bottom filling
    },
    navigation: {
      nextEl: ".ImgFeat-button-next",
      prevEl: ".ImgFeat-button-prev",
    },
    breakpoints: {
      640: {
        slidesPerView: 3,
        slidesPerGroup: 1,
        spaceBetween: 0,
        grid: {
          rows: 2
        }
      },
      768: {
        slidesPerView: 4,
        slidesPerGroup: 2,
        spaceBetween: 0,
        grid: {
          rows: 2
        }
      },
      1024: {
        slidesPerView: 7,
        slidesPerGroup: 7,
        spaceBetween: 0,
        grid: {
          rows: 2
        }
      }
    }
  });

var Videolist = new Swiper(".videoList_slide", {
  slidesPerView: 2.2,
  loop: false,
  spaceBetween: 10,
  grabCursor: true,
  pagination: {
    el: ".swiper-pagination.VideoPagi",
    clickable: true,
  },
  breakpoints: {
    640: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 4,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 20,
    }
  }
});

// ---- Hover-based drag logic ---- //
let lastX = null;
let isHovering = false;
let cooldown = false; // To prevent rapid fire sliding

const sliderEl = document.querySelector('.videoList_slide');

// Guard: this slider only exists on pages that render the video list
// section. Without it, every other page threw a TypeError here.
if (sliderEl) {

sliderEl.addEventListener('mouseenter', () => {
  isHovering = true;
});

sliderEl.addEventListener('mouseleave', () => {
  isHovering = false;
  lastX = null;
});

sliderEl.addEventListener('mousemove', (e) => {
  if (!isHovering || cooldown) return;

  if (lastX === null) {
    lastX = e.clientX;
    return;
  }

  const diff = e.clientX - lastX;

  if (diff > 20) {
    Videolist.slidePrev();
    lastX = e.clientX;
    cooldown = true;
    setTimeout(() => cooldown = false, 400); // Add small delay
  } else if (diff < -20) {
    Videolist.slideNext();
    lastX = e.clientX;
    cooldown = true;
    setTimeout(() => cooldown = false, 400);
  }
});

}

});
  document.addEventListener('DOMContentLoaded', function () {
    // Guard: the flavor metaobjects JSON only renders on templates that
    // include it. Without the check, every other page threw a TypeError
    // here and killed the rest of this listener.
    const flavorJsonEl = document.getElementById('flavor-metaobjects-json');
    const flavorData = flavorJsonEl ? JSON.parse(flavorJsonEl.textContent) : {};
    const flavorInputSelector = '.product-form__input--flavor input[type="radio"]';
    const flavorDescription = document.getElementById('flavor-description');

    function updateFlavorDescription() {
      const selectedInput = document.querySelector(`${flavorInputSelector}:checked`);
      if (!selectedInput) return;

      const selectedFlavor = selectedInput.value;
      const content = flavorData[selectedFlavor]?.content || '';

      if (flavorDescription) {
        flavorDescription.innerHTML = content;
      }
    }

    // Initial call
    updateFlavorDescription();

    // Listen for changes
    document.querySelectorAll(flavorInputSelector).forEach(input => {
      input.addEventListener('change', updateFlavorDescription);
    });

    $(document).ready(function () {
      function toggleGalleryNav() {
        if ($('.menu-opening').length > 0) {
          $('.gallery_nav-btn').hide();
        } else {
          $('.gallery_nav-btn').show();
        }
      }
      // Monitor menu open/close
      const observer = new MutationObserver(toggleGalleryNav);
      observer.observe(document.body, {
        childList: true,
        attributes: true,
        subtree: true
      });
      toggleGalleryNav(); // Initial call
    });



  });


document.addEventListener('DOMContentLoaded', function () {

  var currentPer = $('.product-form__input--size.product-form__input--pill input[type=radio]:checked+label .discount-percentage').html();
  var currentInterval = $('.product-form__input--size.product-form__input--pill input[type=radio]:checked+label .discount-percentage').data('interval');

   $('.var-price').html(currentPer);
   $('.var-interval').html(currentInterval);

  const drawer = document.getElementById('custom-drawer');
  const openBtn = document.querySelector('.open-drawer-btn');

  // Guard moved ABOVE the drawer.querySelector calls — it used to sit
  // below them, so pages without the drawer threw before reaching it.
  if (!openBtn || !drawer) return;

  const closeBtn = drawer.querySelector('.close-drawer-btn');
  const overlay = drawer.querySelector('.drawer-overlay');
  const drawerContent = drawer.querySelector('.drawer-content');

  function openDrawer() {
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    openBtn.setAttribute('aria-expanded', 'true');
    document.body.classList.add('drawer-open');
  }

  function closeDrawer() {
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    openBtn.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('drawer-open');
  }

  openBtn.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);

  // Close drawer on clicking outside drawer content
  document.addEventListener('mousedown', function (e) {
    if (
      drawer.classList.contains('open') &&
      (!drawerContent || !drawerContent.contains(e.target)) &&
      !openBtn.contains(e.target) // prevent closing if click is on the open button itself
    ) {
      closeDrawer();
    }
  });

  // Escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.classList.contains('open')) {
      closeDrawer();
    }
  });
});


 document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      const targetId = this.getAttribute('href').substring(1);
      const targetElement = document.getElementById(targetId);
      if (targetElement) {
        e.preventDefault();
        targetElement.scrollIntoView({
          behavior: 'smooth'
        });
      }
    });
  });
});